import React from "react"
import clsx from "clsx"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { t } from "../helpers/format"

const SelectionBar = ({ count, busy, onClear, onApprove }) => (
  <div
    className = {clsx(
      "fixed left-1/2 bottom-6 z-40 -translate-x-1/2 transition-all duration-200",
      count > 0 ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
    )}
    aria-hidden = {count === 0}
  >
    <div className="flex items-center gap-3 pl-4 pr-2 py-2 rounded-xl bg-slate-900 text-white border border-slate-800">
      <span className="inline-grid place-items-center min-w-[24px] h-[24px] px-1.5 rounded-full bg-brand-500 text-[12px] font-bold tabular-nums">
        {count}
      </span>
      <span className="text-[13px] font-medium">{t("selection.count", { count })}</span>
      <button type="button" onClick={onClear} className="h-8 px-2.5 rounded-md text-[12.5px] text-slate-300 hover:text-white hover:bg-white/10">
        {t("selection.clear")}
      </button>
      <button
        type      = "button"
        disabled  = {busy}
        onClick   = {onApprove}
        className = "inline-flex items-center gap-1.5 h-8 px-3 rounded-md bg-emerald-500 hover:bg-emerald-400 text-[12.5px] font-semibold disabled:opacity-50"
      >
        <FontAwesomeIcon icon={busy ? "circle-notch" : "check"} spin={busy} />
        {t("selection.approve", { count })}
      </button>
    </div>
  </div>
)

export default SelectionBar
